import React from 'react';
import { PatientCard } from './PatientCard';
import { PrimaryButton } from './PrimaryButton';
import { teaserPatients } from '../../data/teaser';
type HookScreenProps = {
  onAnswer: (answer: 'yes' | 'no') => void;
};
export function HookScreen({
  onAnswer
}: HookScreenProps) {
  return <div className="flex h-full flex-col" data-id="element-753" data-mp="38jcrv2rze9hl">
      <h1 className="text-[30px] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-754" data-mp="38hjkfl9jnl8j">
        Same goal.
        <br data-id="element-755" data-mp="3nej1dzqacqfo" />
        Same starting approach?
      </h1>
      <p className="mt-3 text-[15px] leading-snug text-graphite" data-id="element-756" data-mp="3ii2c327co610">Two patients. Different ovarian reserve. Different body weight.</p>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-757" data-mp="2rsmdp5iuro">
        {teaserPatients.map(p => <PatientCard key={p.id} patient={p} data-id="element-758" data-mp="3s8djiyq8sxcn" />)}
      </div>

      <div className="mt-auto pt-6" data-id="element-759" data-mp="a0xooeoa16om">
        <p className="text-center text-[17px] font-medium tracking-[-0.01em] text-ink" data-id="element-760" data-mp="a1z7547mgvgd">Would you approach them the same way?</p>
        <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-761" data-mp="50jil268k6t8">
          <PrimaryButton variant="outline" onClick={() => onAnswer('yes')} data-id="element-762" data-mp="29uukm37cdhuc">
            YES
          </PrimaryButton>
          <PrimaryButton variant="outline" onClick={() => onAnswer('no')} data-id="element-763" data-mp="2esw4urgi7n7e">
            NO
          </PrimaryButton>
        </div>
      </div>
    </div>;
}